import graphql__fdb0784e1f88f85271c7 from "./__generated__/CreateMarketingEmailDialogMutation.graphql.ts";import * as React from "react";
import {graphql, useMutation} from "react-relay";
import {useNavigate} from "react-router-dom";
import * as yup from "yup";
import FormDialog from "./FormDialog";
import Section from "../form/Section";
import Row from "../form/Row";
import Label from "../form/Label";
import Field from "../form/Field";
import {useIntl} from "react-intl";
import {useErrorContext} from "../../contexts/ErrorContext";
import type {CreateMarketingEmailDialogMutation} from "./__generated__/CreateMarketingEmailDialogMutation.graphql";

type Props = {
    handleCloseDialog: () => void
}

const CreateMarketingEmailDialog: React.FC<Props> = ({handleCloseDialog}) => {
    const intl = useIntl();
    const navigate = useNavigate();
    const {addError} = useErrorContext();

    const [commitMutation] = useMutation<CreateMarketingEmailDialogMutation>(graphql__fdb0784e1f88f85271c7);

    const handleSubmission = (values: {name: string}) => {
        commitMutation({
            variables: {
                input: {
                    name: values.name
                }
            },
            onCompleted: (response) => {
                handleCloseDialog();
                if (response.createMarketingEmail?.id) {
                    navigate(`/marketing/emails/${response.createMarketingEmail.id}`);
                }
            },
            onError: () => {
                addError({
                    type: 'general',
                    message: intl.formatMessage({id: 'errors.failedToCreateMarketingEmail'})
                });
                handleCloseDialog();
            }
        });
    };

    const validationSchema = yup.object().shape({
        name: yup.string()
            .required(intl.formatMessage({id: 'validation.field.required'}))
            .min(3, intl.formatMessage({id: 'validation.field.nameTooShort'}))
            .max(100, intl.formatMessage({id: 'validation.field.nameTooLong'}))
    });

    return (
        <FormDialog
            handleCloseDialog={handleCloseDialog}
            handleSubmission={handleSubmission}
            initialValues={{name: ''}}
            validationSchema={validationSchema}
            headline={intl.formatMessage({id: 'dialog.CreateMarketingEmailDialog.headline'})}
            submitLabel={intl.formatMessage({id: 'button.create'})}
        >
            <Section>
                <Row>
                    <Label>{intl.formatMessage({id: 'dialog.CreateMarketingEmailDialog.nameLabel'})}</Label>
                    <Field
                        name="name"
                        type="text"
                        autoFocus={true}
                        placeholder={intl.formatMessage({id: 'dialog.CreateMarketingEmailDialog.namePlaceholder'})}
                    />
                </Row>
            </Section>
        </FormDialog>
    );
};

export default CreateMarketingEmailDialog;
